/** The sphere's face when there is no video: up to two initials. */
export function SphereInitials({ name }: { name: string }) {
  const initials = name
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase()
  return <span className="lv-sphere-initials">{initials || '··'}</span>
}
